import React from  "react";
import cookie from "react-cookies";
import axios from "axios";
import {Row, Col, List, Icon, Typography, Slider} from 'antd'
import { AuthHeader } from "../../../../helper/auth.token";
import Feature from 'ol/Feature';
import Polygon from 'ol/geom/Polygon';
import { Fill, Stroke, Style, Text as OlText } from 'ol/style.js';
import { Vector as VectorSource } from 'ol/source.js';
import LineString from 'ol/geom/LineString';
import Circle from 'ol/geom/Circle';
import { getIcon } from './drawing/draw_tool_maker';
import { getFormattedLength, getFormattedArea, convertSettingsToFilter, getPrefixedUrl } from '../../../../utils/utils';
import CommentComp from "../comments";

const {Text} = Typography;

export const getAnnotationList = (slide_id, taggerKey, updateStateCallback) => {
    let url = `/api/annotation/?slide=${slide_id}&anno_drawer=${taggerKey}`;
    axios
    .get(url, { headers: { Authorization: AuthHeader() } })
    .then(response => {
        let data = response.data;
        updateStateCallback(data);
    })
    .catch(err => {
        console.log("Failed Annotation", err);
    });
}

export const addAnnotation = (area, perimeter, key, coord, center, taggerType, z, slide_id, updateAnnotationsCallback) => {

    let value = {
        area: area,
        perimeter: perimeter,
        color: "#36454f",
        new_bounds: coord,
        slide: slide_id,
        creator: parseInt(cookie.load('user_id')),
        shape: key.db_key,
        tool_type: key.name,
        center: center.toString(), 
        anno_drawer: taggerType,
        created_z_level: z
    };

    postAnnotationToHelper(value, updateAnnotationsCallback);
}

const addTitle = (annotation, title, updateAnnotationsCallback) => {
    annotation.title = title;
    let url = `/api/annotation/` + annotation.id + '/';
    axios
    .put(url, annotation, { headers: { Authorization: AuthHeader() } })
    .then(response => {
        updateAnnotationsCallback();
    })
    .catch(err => {
        console.log("Annotation add failed", err);
    });
}

const postAnnotationToHelper = (value, updateAnnotationsCallback) => {
    let url = `/api/annotation/`;
    axios
    .post(url, value, { headers: { Authorization: AuthHeader() } })
    .then(response => {
        updateAnnotationsCallback();
    })
    .catch(err => {
        console.log("Annotation add failed", err);
    });
}

const annoColor = "#36454f";

const baseText = new OlText({
    font: 'bold 20px "Open Sans", "Helvetica", "sans-serif"',
    placement: 'line',
    textBaseline: 'top',
    fill: new Fill({
        color: annoColor
    }), 
    backgroundFill: new Fill({
        color: "#ffffff"
    }), 
    backgroundStroke: new Fill({
        color: "#ffffff"
    })
})

const baseStyle = new Style({
    stroke: new Stroke({
        color: annoColor,
        width: 2
    }),
    fill: new Fill({
        color: 'rgba(255, 0, 0, 0.0)'
    })
});

const selectedStyle = new Style({
    stroke: new Stroke({
        color: "#00b3ff", 
        width: 8
    })
})

const otherStyle = new Style({
    stroke: new Stroke({
        color: "white", 
        width: 5
    })
})

const styleFunction = (feature, resolution) => {
    let baseStyleWithText = baseStyle;
    baseText.setText(feature.get('title'));
    baseStyleWithText.setText(baseText);
    if (feature.getProperties().color != undefined && feature.getProperties().color != "") {
        baseStyleWithText.getStroke().setColor(feature.getProperties().color);
    }
    if (feature.getProperties().selected) {
        return [
            selectedStyle, baseStyleWithText
        ]
    } else {
        return [
            otherStyle, baseStyleWithText
        ]
    }
}

export const drawAnnotations = (vector, annotations, selectedAnnotationId) => {
    let allFeatures = [];
    annotations.map((annotation, index) => {
        let feature;
        if (annotation.new_bounds !== null) {
            if (annotation.shape === "polygon") {
                feature = new Feature({
                    geometry: new Polygon(JSON.parse(annotation.new_bounds)),
                    id: annotation.id,
                    name: annotation.shape,
                    title: annotation.title,
                });
            }
            else if (annotation.shape === "line") {
                feature = new Feature({
                    geometry: new LineString(JSON.parse(annotation.new_bounds)),
                    id: annotation.id,
                    name: annotation.shape,
                    title: "",
                });
            }
            else if (annotation.shape === "circle") {
                let bounds = JSON.parse(annotation.new_bounds);
                let center = bounds[0];
                let radius = bounds[1];
                feature = new Feature({
                    geometry: new Circle(center, radius),
                    id: annotation.id,
                    name: annotation.shape,
                    title: ""
                });
            }
            feature.setId(annotation.id);
            feature.set('creator', annotation.anno_drawer);
            feature.set('selected', annotation.id == selectedAnnotationId);
            feature.set('color', annotation.color);
            allFeatures.push(feature);
        }
        return feature;
    });

    vector.setSource(new VectorSource({
        features: allFeatures,
        wrapX: false
    }))

    vector.setStyle(styleFunction);
}

const colorMap = {
    "0.2x": "red", 
    "0.4x": "#3498db",
    "0.7x": "#27ae60",
    "1.3x": "#8e44ad",
    "2.5x": "#34495e", 
    "5x": "#e84118",
    "10x": "#f6b93b",
    "20x": "#27ae60",
    "40x": "#3498db", 
    "80x": "#2c3e50",
    "100x": "#d35400",
    "200x": "#B53471",
}

export const getAnnotationsInListView = (currentAnnotations, slide, selectedAnnotationId, onSelectAnnotation, 
                settings, zoomScale, onDeleteAnnotation, doRefreshAnnotationsFromBackend) => {

    let annotationList, selectedAnnotationDrawer;

    if (currentAnnotations.length > 0) {
        annotationList =  <Col key={0}
                                className="annotation-list scrollbar" 
                                span={10}>
                                <List
                                    size="small"
                                    bordered
                                    dataSource={currentAnnotations}
                                    renderItem={(item, index) => <List.Item 
                                                                    key={item.id} 
                                                                    style={{cursor: 'pointer'}}
                                                                    className={item.id == selectedAnnotationId ? "selected-annotation" : ""} 
                                                                    onClick={()=> onSelectAnnotation(item, index)}>
                                                                    {cookie.loadAll().deployment_mode === 'offline' ? 
                                                                        [<div
                                                                            key={0} 
                                                                            className="annotation-magnification-indicator annotation-magnification-indicator-list-view unselectable" 
                                                                            style={{backgroundColor: colorMap[zoomScale[item.created_z_level] + "x"], zIndex: 2}}>
                                                                            {zoomScale[item.created_z_level] + "x"}
                                                                        </div>, 
                                                                        <img 
                                                                            key={1}
                                                                            className="annotation-crop"
                                                                            style={{filter:convertSettingsToFilter(settings), zIndex: 1}}
                                                                            src={getPrefixedUrl(slide.bucket_name + '/' + slide.path + '/ugc/annotations/' + item.id + '.jpg', slide)} />
                                                                        ] : [
                                                                        <Text key={0} style={{fontSize:12}} className="unselectable" ellipsis={true}>
                                                                            {item.title}
                                                                        </Text>, 
                                                                        <div key={1} className="annotation-item-shape-icon">
                                                                            {getIcon(item)}
                                                                        </div>
                                                                        ]}
                                                                    <Icon className="delete-annotation" type="close-circle" onClick={
                                                                        (e) => onDeleteAnnotation(e, item.id, index)
                                                                        }>
                                                                    </Icon>
                                                                </List.Item>}
                                />
                            </Col>;
    
        let selectedAnnotationContent;
    
        if (selectedAnnotationId != null) {
            let selected;
            for (let i = 0; i < currentAnnotations.length; i++) {
                if (currentAnnotations[i].id == selectedAnnotationId) {
                    selected = currentAnnotations[i];
                    break;
                }
            }
            selectedAnnotationContent = <Col className="selected-annotation-drawer">
                                                <Row
                                                    className="annotation-title" >
                                                    <Text 
                                                        strong={true}
                                                        editable={{ onChange: (newTitle) => addTitle(selected, newTitle, doRefreshAnnotationsFromBackend)}}>
                                                        {selected.title === "" ? "Add Title" : selected.title}
                                                    </Text>
                                                </Row>
                                                { selected.shape == "line" ? 
                                                    <Row>
                                                        <b>Length : </b>{getFormattedLength(selected.perimeter)}
                                                    </Row> :
                                                    [<Row key = {0}>
                                                        <b>Area : </b>{getFormattedArea(selected.area)}
                                                    </Row>, 
                                                    <Row key = {1}>
                                                        <b>Perimeter : </b>{getFormattedLength(selected.perimeter)}
                                                    </Row>]
                                                }
                                                <CommentComp annoId={selected.id}/>
                                            </Col>
        }

        selectedAnnotationDrawer = <Col key={1}
                                        span={14}
                                        className="selected-annotation-drawer-col">
                                        <Row 
                                            className="selected-annotation-drawer-row">
                                            {selectedAnnotationId != null ? 
                                                selectedAnnotationContent : <div className="no-annotation-placeholder unselectable">No Annotation Selected</div>}
                                        </Row>
                                    </Col>
    }

    return [
        annotationList, 
        selectedAnnotationDrawer
    ]
}

export const getAnnotationsInGridView = (currentAnnotations, selectedAnnotationId, zoomScale, 
    slide, onSelectAnnotation, onDeleteAnnotation, refreshAnnotationsFromBackend, settings, 
    imgsPerCol, onChangeColSize) => {

    let annotationsGridParent, selectedAnnotationDrawer;

    let colSpan = parseInt(24 / imgsPerCol);
    let currentImgCount = 0;
    let annotationRow = [];
    let annotationsGrid = [];

    for (let index = 0; index < currentAnnotations.length; index++){
        let annotation = currentAnnotations[index];
        let annotationDiv;

        if (annotation.shape === 'line') {

        } else {
            annotationDiv = <Col key={currentImgCount} className="annotation-crop-div" span={colSpan}>
                    <Icon 
                        className="delete-annotation-grid-view" 
                        type="close-circle"
                        style={{zIndex: 2}}
                        onClick={
                            (e) => onDeleteAnnotation(e, annotation.id, index)
                        }>
                    </Icon>
                    <div 
                        className="annotation-magnification-indicator unselectable" 
                        style={{backgroundColor: colorMap[zoomScale[annotation.created_z_level] + "x"], zIndex: 2}}>
                        {zoomScale[annotation.created_z_level] + "x"}
                    </div>
                    <img 
                        className="annotation-crop"
                        style={{filter:convertSettingsToFilter(settings), zIndex: 1}}
                        src={getPrefixedUrl(slide.bucket_name + '/' + slide.path + '/ugc/annotations/' + annotation.id + '.jpg', slide)} />
                </Col>
        }

        if (currentImgCount == imgsPerCol) {
            annotationsGrid.push(<Row key={annotationsGrid.length}>{annotationRow}</Row>);
            annotationRow = [];
            currentImgCount = 0;
        }

        annotationRow.push(annotationDiv);
        currentImgCount ++;
    }

    annotationsGrid.push(<Row key={annotationsGrid.length}>{annotationRow}</Row>);

    let gridSizeControl;

    if (currentAnnotations.length > 0) {
        gridSizeControl =  <Row>
                            <Col span={4} style={{padding:"0.6em"}}>Grid Size</Col>
                            <Col span={20}>
                                <Slider
                                    className="grid-size-slider"
                                    min={2}
                                    max={6}
                                    onChange={onChangeColSize}
                                    value={imgsPerCol} />
                            </Col>
                            </Row>
    }

    annotationsGridParent = 
        <Row className="annotations-grid scrollbar">
            {gridSizeControl}
            {annotationsGrid}
        </Row>

    return [
        annotationsGridParent, 
        selectedAnnotationDrawer
    ]
}